import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { Link, useNavigate } from 'react-router-dom';
import { RxCross2, RxHamburgerMenu } from 'react-icons/rx';
import { openInNewTab } from '../utils/helpers/helpers';
import { cn } from '../utils/cn';
import { useState, useEffect } from 'react';
import { Button } from './ui/button';

const PublicHeader = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      data-testid='public-header'
      className={cn(
        'sticky top-0 z-50 mx-auto max-w-screen bg-white transition-shadow duration-200',
        isScrolled && 'shadow-md'
      )}
    >
      <div className='container mx-auto flex h-18 flex-row items-center justify-between gap-x-3.5 bg-white'>
        <div className='flex w-full flex-row items-center'>
          <Link to='/home' title='HireMySub.com' className='flex-none pr-5'>
            <span className='sr-only'>HireMySub</span>
            <img
              src='https://cdn.hiremysub.com/hmsDefaultLogo.png'
              className='w-40'
              alt='HireMySub Logo'
            />
          </Link>
        </div>

        <div className='tablet:flex tablet:gap-5 hidden'>
          <Button
            variant='ghost'
            size='sm'
            onClick={() => navigate('/pro/home')}
            title='Join as a Sub'
            className='w-28'
          >
            Join as a Sub
          </Button>
          <Button
            variant='inverse'
            size='sm'
            aria-label='Login (opens in a new tab)'
            onClick={() => {
              if (import.meta.env.MODE !== 'production') {
                openInNewTab('http://localhost:3333/login');
              } else {
                openInNewTab('https://portal.hiremysub.com/login');
              }

              close();
            }}
            className='w-28'
          >
            Login
          </Button>
          <Button
            variant='brand'
            size='sm'
            onClick={() => {
              navigate('/join');
            }}
            className='w-28'
            aria-label='Sign Up (navigates to sign up page)'
          >
            Sign Up
          </Button>
        </div>

        {/* Mobile Navigation */}
        <Popover as='div' className='tablet:hidden ml-auto'>
          {({ close }) => (
            <>
              <div className='flex items-center gap-2'>
                <Button
                  variant='ghost'
                  onClick={() => navigate('/pro/home')}
                  title='Join as a Sub'
                  className='w-40'
                >
                  Join as a Sub
                </Button>
                <PopoverButton
                  className='cursor-pointer'
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                  <span className='sr-only'>
                    {isMobileMenuOpen ? 'Close menu' : 'Open menu'}
                  </span>
                  {isMobileMenuOpen ? (
                    <RxCross2
                      className='h-6 w-6'
                      aria-hidden='true'
                      color='#3B82F6'
                    />
                  ) : (
                    <RxHamburgerMenu
                      className='h-6 w-6'
                      aria-hidden='true'
                      color='#3B82F6'
                    />
                  )}
                </PopoverButton>
              </div>

              <PopoverPanel
                className='fixed top-0 left-0 -z-50 max-h-full min-h-48 w-full overflow-y-auto overscroll-none rounded-b border-b bg-white shadow-lg'
                style={{ display: isMobileMenuOpen ? 'block' : 'none' }}
              >
                <div className='container mx-auto flex h-screen flex-col divide-y px-6'>
                  <div className='w-full pt-22'>
                    <Button
                      variant='inverse'
                      role='link'
                      aria-label='Login (opens in a new tab)'
                      onClick={() => {
                        if (import.meta.env.MODE !== 'production') {
                          openInNewTab('http://localhost:3333/login');
                        } else {
                          openInNewTab('https://portal.hiremysub.com/login');
                        }

                        close();
                        setIsMobileMenuOpen(false);
                      }}
                      className='mb-3.5 w-full uppercase'
                    >
                      Login
                    </Button>
                    <Button
                      variant='brand'
                      onClick={() => {
                        navigate('/join');
                        close();
                        setIsMobileMenuOpen(false);
                      }}
                      className='w-full uppercase'
                    >
                      Sign Up
                    </Button>
                  </div>
                </div>
              </PopoverPanel>
            </>
          )}
        </Popover>
      </div>
    </div>
  );
};

export default PublicHeader;
